"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var idm_common_util_frontend_1 = require("@synisys/idm-common-util-frontend");
var ComboboxGroup = /** @class */ (function () {
    /**
     * Constructs the option with provided properties.
     * @param {T1} items
     * @param {T2} name
     */
    function ComboboxGroup(items, name) {
        this.items = items;
        this.name = name;
        idm_common_util_frontend_1.PreconditionCheck.notNullOrUndefined(items);
        idm_common_util_frontend_1.PreconditionCheck.notNullOrUndefined(name);
    }
    ;
    return ComboboxGroup;
}());
exports.ComboboxGroup = ComboboxGroup;
//# sourceMappingURL=combobox-group.js.map